import $ from "jquery";
/**@module vue/plugins/jQuery
 * @desc Vue Plugin Wrapper for jQuery see {@link https://jquery.com/}
 * @requires jquery
*/
const plugin = {
    install(Vue){
        Vue.prototype.$$ = $;
    }
}

export default plugin;

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin)
}